module.exports = __webpack_public_path__ + "img/information.3d9327b4.svg";